import React, { useState } from "react";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Variwide from "highcharts/modules/variwide";

Variwide(Highcharts);

// Sample nested data structure
const data = {
  "Cigna Carelink": {
    "Category III Codes": {
      "Procedures performed on Cornea": {
        "Medicare Weight": 1.0,
        "% Medicare": 84.77,
        "% Discount": -12.65056361,
        "% Completeness": 100.0,
      },
      "Wound Imaging for Bacterial Presence": {
        "Medicare Weight": 1.0,
        "% Medicare": 231.33,
        "% Discount": -36.25120773,
        "% Completeness": 100.0,
      },
      "Laser Ablation Procedures": {
        "Medicare Weight": 1.0,
        "% Medicare": 99.975,
        "% Discount": -15.09903382,
        "% Completeness": 100.0,
      },
      "Cardiac Rhythm Monitor System Evaluation": {
        "Medicare Weight": 1.0,
        "% Medicare": 536.43,
        "% Discount": -85.38164251,
        "% Completeness": 100.0,
      },
      "Procedures Performed on Prostate": {
        "Medicare Weight": 1.24,
        "% Medicare": 124.21,
        "% Discount": -19.00161031,
        "% Completeness": 100.0,
      },
      "Trabeculostomy Procedure by Laser (Ab Interno)": {
        "Medicare Weight": 1.98,
        "% Medicare": 146.83,
        "% Discount": -22.64412238,
        "% Completeness": 100.0,
      },
      "Ocular Telescope Prosthesis Insertion Procedure": {
        "Medicare Weight": 1.0,
        "% Medicare": 83.78,
        "% Discount": -12.49114332,
        "% Completeness": 100.0,
      },
      "Insertion of Aqueous Drainage Device": {
        "Medicare Weight": 1.0,
        "% Medicare": 102.5604167,
        "% Discount": -15.515365,
        "% Completeness": 100.0,
      },
      "Quantitative Ultrasound Tissue Characterization": {
        "Medicare Weight": 1.0,
        "% Medicare": 233.15,
        "% Discount": -36.54428341,
        "% Completeness": 100.0,
      },
      "Vision Studies, Implants and Therapies": {
        "Medicare Weight": 1.0,
        "% Medicare": 161.16,
        "% Discount": -24.95169082,
        "% Completeness": 100.0,
      },
      "High Dose Rate Electronic Brachytherapy Procedures": {
        "Medicare Weight": 2.0,
        "% Medicare": 204.925,
        "% Discount": -31.99919485,
        "% Completeness": 100.0,
      },
      "Subchondral Bone Defect Injection Procedure": {
        "Medicare Weight": 3.06,
        "% Medicare": 145.6223571,
        "% Discount": -22.44965493,
        "% Completeness": 100.0,
      },
      "Percutaneous Cryoablation Procedures": {
        "Medicare Weight": 5.06,
        "% Medicare": 114.3475,
        "% Discount": -17.41344605,
        "% Completeness": 80.23715415,
      },
      "Various Services - Category III Codes": {
        "Medicare Weight": 59.25,
        "% Medicare": 101.939674,
        "% Discount": -15.41540644,
        "% Completeness": 66.17721519,
      },
      "Imaging, Testing, Implantation and Other Services": {
        "Medicare Weight": 41.52,
        "% Medicare": 98.19850845,
        "% Discount": -14.81296432,
        "% Completeness": 61.46435453,
      },
      "Carotid Sinus Baroreflex Activation Device Procedures": {
        "Medicare Weight": 12.42,
        "% Medicare": 85.70129283,
        "% Discount": -12.80053025,
        "% Completeness": 51.69082126,
      },
      "Permanent Cardiac Contractility Modulation System Procedures": {
        "Medicare Weight": 23.15,
        "% Medicare": 94.69638674,
        "% Discount": -14.24901558,
        "% Completeness": 50.1511879,
      },
      "Neurofibroma Destruction Procedure": {
        "Medicare Weight": 2.0,
        "% Medicare": 249.04,
        "% Discount": -39.10305958,
        "% Completeness": 50.0,
      },
      "Tissue Characterization by Quantitative CT": {
        "Medicare Weight": 2.0,
        "% Medicare": 395.95,
        "% Discount": -62.76006441,
        "% Completeness": 50.0,
      },
      "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
        "Medicare Weight": 90.18,
        "% Medicare": 111.0541304,
        "% Discount": -16.88311279,
        "% Completeness": 50.0,
      },
      "Percutaneous Decompressive Laminotomy/Laminectomy Procedures through Interlaminar Approach":
        {
          "Medicare Weight": 21.46,
          "% Medicare": 113.2967164,
          "% Discount": -17.24423775,
          "% Completeness": 50.0,
        },
      "Quantitative Magnetic ResoUnavailablece Tissue Composition Analysis": {
        "Medicare Weight": null,
        "% Medicare": 679.82,
        "% Discount": -108.4718196,
        "% Completeness": 50.0,
      },
      "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
        "Medicare Weight": 42.97,
        "% Medicare": 106.4828352,
        "% Discount": -16.14699439,
        "% Completeness": 43.91435886,
      },
      "Insertion and Removal of Implantable Interstitial Glucose Sensor": {
        "Medicare Weight": 3.0,
        "% Medicare": 105.87,
        "% Discount": -16.04830918,
        "% Completeness": 33.33333333,
      },
      "Neurostimulation Procedures": {
        "Medicare Weight": 4.0,
        "% Medicare": 117.695,
        "% Discount": -17.95249597,
        "% Completeness": 25.0,
      },
    },
    "Miscellaneous Medical Services": {
      "Miscellaneous Medical Services": {
        "Medicare Weight": 16.0,
        "% Medicare": 166.2419643,
        "% Discount": -25.77004256,
        "% Completeness": 25.0,
      },
    },
  },
  "Cigna Arizona HMO": {
    "Category III Codes": {
      "Subchondral Bone Defect Injection Procedure": {
        "Medicare Weight": 3.06,
        "% Medicare": 95.59,
        "% Discount": -14.39291465,
        "% Completeness": 100.0,
      },
      "Insertion of Aqueous Drainage Device": {
        "Medicare Weight": 1.0,
        "% Medicare": 78.24,
        "% Discount": -11.59903382,
        "% Completeness": 100.0,
      },
      "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
        "Medicare Weight": 90.18,
        "% Medicare": 144.03,
        "% Discount": -22.19323671,
        "% Completeness": 50.0,
      },
      "Percutaneous Decompressive Laminotomy/Laminectomy Procedures through Interlaminar Approach":
        {
          "Medicare Weight": 21.46,
          "% Medicare": 120.319,
          "% Discount": -18.37504026,
          "% Completeness": 50.0,
        },
      "Permanent Cardiac Contractility Modulation System Procedures": {
        "Medicare Weight": 23.15,
        "% Medicare": 85.38716305,
        "% Discount": -12.74994574,
        "% Completeness": 45.83153348,
      },
      "Carotid Sinus Baroreflex Activation Device Procedures": {
        "Medicare Weight": 12.42,
        "% Medicare": 87.065,
        "% Discount": -13.02012882,
        "% Completeness": 43.63929147,
      },
      "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
        "Medicare Weight": 42.97,
        "% Medicare": 91.21,
        "% Discount": -13.68760064,
        "% Completeness": 15.87153828,
      },
    },
  },
  "Cigna Central Florida": {
    "Category III Codes": {
      "Subchondral Bone Defect Injection Procedure": {
        "Medicare Weight": 3.06,
        "% Medicare": 102.7025,
        "% Discount": -15.53824477,
        "% Completeness": 100.0,
      },
      "Insertion of Aqueous Drainage Device": {
        "Medicare Weight": 1.0,
        "% Medicare": 70.12,
        "% Discount": -10.29146538,
        "% Completeness": 100.0,
      },
      "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
        "Medicare Weight": 90.18,
        "% Medicare": 113.895,
        "% Discount": -17.34057971,
        "% Completeness": 50.0,
      },
      "Percutaneous Decompressive Laminotomy/Laminectomy Procedures through Interlaminar Approach":
        {
          "Medicare Weight": 21.46,
          "% Medicare": 82.4625,
          "% Discount": -12.27898551,
          "% Completeness": 50.0,
        },
      "Percutaneous Cryoablation Procedures": {
        "Medicare Weight": 5.06,
        "% Medicare": 149.27,
        "% Discount": -23.03703704,
        "% Completeness": 40.11857708,
      },
      "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
        "Medicare Weight": 42.97,
        "% Medicare": 90.34,
        "% Discount": -13.54750403,
        "% Completeness": 28.04282057,
      },
      "Various Services - Category III Codes": {
        "Medicare Weight": 59.25,
        "% Medicare": 604.318,
        "% Discount": -96.3136876,
        "% Completeness": 1.687763713,
      },
    },
  },
};

const colorPalette = [
  "#c0e7e7",
  "#507a8a",
  "#d1e8ff",
  "#ffd29f",
  "#f7bf9e",
  "#f7e6da",
  "#f4e7bb",
  "#c2e2ea",
  "#d7e3fc ",
  "#F8D7DD",
  "#F7C6B5",
  "#D7FBFB",
];

const DrugProceduresChart = () => {
  const networks = Object.keys(data);
  const categories = networks.length > 0 ? Object.keys(data[networks[0]]) : [];
  const metrics = ["% Completeness", "% Medicare", "% Discount"];
  const [selectedNetwork, setSelectedNetwork] = useState(networks[0]);
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const [selectedMetric, setSelectedMetric] = useState(metrics[0]);
  const procedures = data[selectedNetwork]?.[selectedCategory] ?? {};
  const transformedData = Object.entries(procedures).map(([name, values]) => ({
    name,
    y: values[selectedMetric],
    z: normalizeWeight(values["Medicare Weight"]),
    realWeight: values["Medicare Weight"],
  }));
  const [expanded, setExpanded] = useState(false);
  const maxVisibleItems = 7;

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const visibleItems = expanded
    ? transformedData
    : transformedData.slice(0, maxVisibleItems);

  function normalizeWeight(weight) {
    if (weight <= 0) return 0.1;
    if (weight <= 1) return 0.5;
    if (weight <= 10) return 2;
    if (weight <= 20) return 3;
    if (weight <= 30) return 4;
    if (weight <= 40) return 5;
    if (weight <= 50) return 6;
    if (weight <= 60) return 7;
    if (weight <= 70) return 8;
    if (weight <= 80) return 9;
    if (weight <= 90) return 10;
    if (weight <= 100) return 11;
    return 12;
  }

  const absoluteData = transformedData.map((item) => ({
    ...item,
    y: Math.abs(item.y),
  }));
  const chartOptions = {
    chart: {
      type: "variwide",
    },
    colors: colorPalette,
    title: {
      text: `${selectedMetric} and Medicare Weight`,
    },
    xAxis: {
      type: "category",
      labels: {
        enabled: false,
        // rotation: 0,
        // style: { fontSize: "12px", whiteSpace: "nowrap" },
      },
    },
    credits: { enabled: false },
    legend: { enabled: false },
    plotOptions: {
      variwide: {
        dataLabels: {
          enabled: true,
        },
      },
    },
    plotOptions: {
      variwide: {
        dataLabels: {
          enabled: false,
        },
      },

      series: {
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
    series: [
      {
        name: selectedMetric,
        data: absoluteData,
        tooltip: {
          pointFormat: `${selectedMetric}: <b>{point.y}</b><br>Medicare Weight: <b>{point.realWeight}</b>`,
        },
        colorByPoint: true,
        borderRadius: 3,
      },
    ],
  };

  return (
    <div
      className="bg-white p-4 "
      style={{ border: "none", borderRadius: "8px", margin: "0px 20px" }}
    >
      <div className="mb-4 d-flex flex-row justify-content-start align-items-center gap-2">
        {/* Network Dropdown */}
        <label className="form-label mb-0">Network:</label>
        <div className="dropdown">
          <a
            className="btn btn-secondary dropdown-toggle p-2"
            href="#"
            variant="primary"
            id="dropdown-basic"
            role="button"
            // id="networkDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {selectedNetwork || "Select Network"}
          </a>
          <ul className="dropdown-menu" aria-labelledby="networkDropdown">
            {networks.map((net) => (
              <li key={net}>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedNetwork(net);
                  }}
                >
                  {net}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Category Dropdown */}
        <label className="form-label mb-0">Category:</label>
        <div className="dropdown">
          <a
            className="btn btn-secondary dropdown-toggle p-2"
            href="#"
            role="button"
            variant="primary"
            id="dropdown-basic"
            // id="categoryDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {selectedCategory || "Select Category"}
          </a>
          <ul className="dropdown-menu" aria-labelledby="categoryDropdown">
            {Object.keys(data[selectedNetwork] || {}).map((cat) => (
              <li key={cat}>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedCategory(cat);
                  }}
                >
                  {cat}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Metric Dropdown */}
        <label className="form-label mb-0">Metric:</label>
        <div className="dropdown">
          <a
            className="btn btn-secondary dropdown-toggle p-2"
            href="#"
            role="button"
            variant="primary"
            id="dropdown-basic"
            // id="metricDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {selectedMetric || "Select Metric"}
          </a>
          <ul className="dropdown-menu" aria-labelledby="metricDropdown">
            {metrics.map((m) => (
              <li key={m}>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedMetric(m);
                  }}
                >
                  {m}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      {selectedMetric === "% Discount" && (
        <div className="metric-details p-2">
          <p style={{ color: "grey", paddingLeft: "3rem" }}>
            <i>
              Note: "The value presented in this chart is an absolute value."
            </i>
          </p>
        </div>
      )}

      <div style={{ marginBottom: "1rem" }}>
        <ul
          style={{
            listStyle: "none",
            padding: 0,
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            justifyContent: "center",
          }}
        >
          {visibleItems.map((item, index) => (
            <li
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "14px",
                fontFamily: "Roboto, sans-serif",
              }}
            >
              <span
                style={{
                  width: "16px",
                  height: "16px",
                  backgroundColor: colorPalette[index % colorPalette.length],
                  display: "inline-block",
                  borderRadius: "4px",
                }}
              />
              {item.name}
            </li>
          ))}

          {transformedData.length > maxVisibleItems && (
            <li
              onClick={toggleExpanded}
              style={{
                cursor: "pointer",
                fontSize: "14px",
                fontFamily: "Roboto, sans-serif",
                color: "#007bff",
                textDecoration: "underline",
              }}
            >
              {expanded ? "See less" : "See more"}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default DrugProceduresChart;
